import { render } from "./RecommendPointRank112.vue?vue&type=template&id=83b0a144&scoped=true"
import script from "./RecommendPointRank112.vue?vue&type=script&lang=js"
export * from "./RecommendPointRank112.vue?vue&type=script&lang=js"

import "./RecommendPointRank112.vue?vue&type=style&index=0&id=83b0a144&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83b0a144"]])

export default __exports__